import { Home, Search, Plus, User, Megaphone } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
      const { user } = useAuth();

      const navItems = [
        {
          icon: Home,
          label: "Home",
          path: "/",
          onClick: () => navigate("/")
        },
        {
          icon: Search,
          label: "Search", 
          path: "/search",
          onClick: () => navigate("/search")
        },
        {
          icon: Plus,
          label: "Post",
          path: "/submit-listing",
          onClick: () => navigate("/submit-listing")
        },
        {
          icon: Megaphone,
          label: "Advertise",
          path: "/advertising",
          onClick: () => navigate("/advertising")
        },
        {
          icon: User,
          label: "Profile",
          path: user ? "/profile" : "/auth",
          onClick: () => navigate(user ? "/profile" : "/auth")
        }
      ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-background border-t border-border px-4 py-2 z-50 shadow-lg">
      <div className="flex justify-around items-center max-w-md mx-auto">
        {navItems.map((item, index) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={index}
              onClick={item.onClick}
              className={`flex flex-col items-center justify-center p-2 rounded-lg transition-all duration-200 ${
                isActive 
                  ? 'text-primary bg-primary/10' 
                  : 'text-muted-foreground hover:text-primary hover:bg-primary/5'
              }`}
            >
              <item.icon className="h-5 w-5 mb-1" />
              <span className="text-xs font-medium">{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNavigation;